import InvoicesService from '../services/InvoicesService';

export default {
  state: {
    invoicesCount: 0,
    invoices: [],
    selectedInvoice: null,
  },
  mutations: {
    async GET_INVOICES_COUNT(state, payload) {
      const {
        searchQuery,
        startDate,
        endDate,
      } = payload;
      state.invoicesCount = await InvoicesService.getInvoicesTableCount(
        searchQuery, startDate, endDate,
      );
    },
    async GET_INVOICES_TABLE_DATA(state, payload) {
      const {
        limit,
        offset,
        searchQuery,
        startDate,
        endDate,
      } = payload;
      state.invoices = await InvoicesService.getInvoicesTable(
        limit, offset, searchQuery, startDate, endDate,
      );
    },
    async SET_SELECTED_INVOICE(state, payload) {
      const {
        invoiceId,
      } = payload;
      state.selectedInvoice = await InvoicesService.getInvoiceById(invoiceId);
    },
  },
  actions: {
    getInvoicesTable({ commit }, payload) {
      commit('GET_INVOICES_COUNT', payload);
      commit('GET_INVOICES_TABLE_DATA', payload);
    },
    setSelectedInvoice({ commit }, payload) {
      commit('SET_SELECTED_INVOICE', payload);
    },
  },
  getters: {
    invoicesCount: state => state.invoicesCount,
    invoices: state => state.invoices,
    selectedInvoice: state => state.selectedInvoice,
  },
};
